<template>
  <div>
    <!--  -->

    <div class="row">
      <div class="col-9">
        <h2>Vendors - Add</h2>
      </div>
      <div class="col-3">
        <router-link to="/vendors" class="btn btn-danger btn-sm float-end"
          >Cancel</router-link
        >
      </div>
    </div>

    <Loader :loaderShow="loaderShow" />

    <Feedback :fbWrapperShow="fbWrapperShow" :fbDiv="fbDiv" :fbMsg="fbMsg" />

    <div class="row" v-if="showForm">
      <div class="col-lg-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <h4 class="mt-3 mb-3 text-center">Fill below form to add vendor</h4>
            <hr />
            <Form @submit="onSubmit">
              <div class="table-responsive mb-3">
                <table class="table table-bordered">
                  <tbody>
                    <tr class="table-secondary">
                      <td style="width: 50%">Latitude</td>
                      <td>Longitude</td>
                    </tr>
                    <tr>
                      <td>{{ addressLatitude }} {{ latLongStatus }}</td>
                      <td>{{ addressLongitude }} {{ latLongStatus }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="mb-3">
                <label
                  >Vendor (Business) Name
                  <span class="text-danger">*</span></label
                >
                <Field
                  type="text"
                  name="vendorName"
                  class="form-control"
                  placeholder="Vendor (Business) Name"
                  v-model="vendorName"
                  :rules="isRequired"
                />
                <ErrorMessage name="vendorName" class="text-danger" />
              </div>
              <div class="mb-2">
                <label
                  >Vendor (Business) Mobile Number
                  <span class="text-danger">*</span></label
                >
                <Field
                  type="text"
                  name="vendorMobile"
                  class="form-control"
                  placeholder="Business Mobile Number"
                  v-model="vendorMobile"
                  :rules="isRequired"
                />
                <ErrorMessage name="vendorMobile" class="text-danger" />
              </div>
              <div class="mb-3">
                <label>Address No <span class="text-danger">*</span></label>
                <Field
                  type="text"
                  name="addressNo"
                  class="form-control"
                  placeholder="Shop No"
                  v-model="addressNo"
                  :rules="isRequired"
                />
                <ErrorMessage name="addressNo" class="text-danger" />
              </div>
              <div class="mb-3">
                <label>Address Line 1 <span class="text-danger">*</span></label>
                <Field
                  type="text"
                  name="addressLine1"
                  class="form-control"
                  placeholder="Address Line 1"
                  v-model="addressLine1"
                  :rules="isRequired"
                />
                <ErrorMessage name="addressLine1" class="text-danger" />
              </div>
              <div class="mb-3">
                <label>Address Line 2 <span class="text-danger">*</span></label>
                <Field
                  type="text"
                  name="addressLine2"
                  class="form-control"
                  placeholder="Address Line 2"
                  v-model="addressLine2"
                  :rules="isRequired"
                />
                <ErrorMessage name="addressLine2" class="text-danger" />
              </div>
              <div class="mb-3">
                <label
                  >Address Landmark <span class="text-danger">*</span></label
                >
                <Field
                  type="text"
                  name="addressLandmark"
                  class="form-control"
                  placeholder="Landmark"
                  v-model="addressLandmark"
                  :rules="isRequired"
                />
                <ErrorMessage name="addressLandmark" class="text-danger" />
              </div>
              <div class="mb-3">
                <label>Address City <span class="text-danger">*</span></label>
                <Field
                  as="select"
                  name="cities"
                  class="form-control"
                  v-model="addressCity"
                  :rules="isRequired"
                >
                  <option value="">Select City</option>
                  <option
                    v-for="item in cities"
                    :value="item.loc_city_id"
                    :key="item.id"
                  >
                    {{ item.loc_city_title }}
                  </option>
                </Field>
                <ErrorMessage name="cities" class="text-danger" />
              </div>
              <div class="mb-3">
                <label
                  >Address Pincode <span class="text-danger">*</span></label
                >
                <Field
                  as="select"
                  name="pincodes"
                  class="form-control"
                  v-model="addressPincode"
                  :rules="isRequired"
                >
                  <option value="">Select Pincode</option>
                  <option
                    v-for="item in pincodes"
                    :value="item.loc_pincode_id"
                    :key="item.id"
                  >
                    {{ item.loc_pincode_num }}
                  </option>
                </Field>
                <ErrorMessage name="pincodes" class="text-danger" />
              </div>
              <div class="mt-5">
                <button
                  type="submit"
                  class="btn btn-primary"
                  :disabled="buttonDisabled"
                >
                  Submit
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>

    <!--  -->
  </div>
</template>

<script>
import { CommonServices } from "@/services/CommonServices";
import Loader from "@/components/Loader.vue";
import Feedback from "@/components/Feedback.vue";

import axios from "axios";
import { POST_VENDORS } from "@/services/ApiConstants";

import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  components: {
    Feedback,
    Loader,
    Form,
    Field,
    ErrorMessage,
  },
  data() {
    return {
      loaderShow: true,
      fbWrapperShow: false,
      fbDiv: "",
      fbMsg: "",
      showForm: true,
      vendorName: "",
      vendorMobile: "",
      addressNo: "",
      addressLine1: "",
      addressLine2: "",
      addressLandmark: "",
      addressCity: "",
      addressPincode: "",
      addressLatitude: "",
      addressLongitude: "",
      addressCurrentPosition: "",
      cities: [],
      pincodes: [],
      buttonDisabled: false,
      latLongStatus: "???",
    };
  },
  watch: {
    addressCity(city) {
      if (city !== "") {
        this.fetchPincodesByCity(city);
      } else {
        this.pincodes = [];
      }
    },
  },
  methods: {
    async fetchCities() {
      let response = await CommonServices.getCities();
      if (response.success) {
        this.cities = response.data;
      }
    },
    async fetchPincodesByCity(city) {
      let response = await CommonServices.getPincodesByCity(city);
      if (response.success) {
        this.pincodes = response.data;
      }
    },
    async detectLatLong() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((currentPosition) => {
          this.addressCurrentPosition = currentPosition;
          this.addressLatitude = currentPosition.coords.latitude;
          this.addressLongitude = currentPosition.coords.longitude;
          this.latLongStatus = "";
        });
      } else {
        this.fbWrapperShow = true;
        this.fbDiv = "alert-danger";
        this.fbMsg = "Geolocation is not supported in this browser";
      }
    },
    async onSubmit() {
      this.buttonDisabled = false;
      this.fbWrapperShow = false;
      this.fbDiv = "";
      this.fbMsg = "";
      let formData = {
        vendorMobile: this.vendorMobile,
        vendorName: this.vendorName,
        addressNo: this.addressNo,
        addressLine1: this.addressLine1,
        addressLine2: this.addressLine2,
        addressLandmark: this.addressLandmark,
        addressCity: this.addressCity,
        addressPincode: this.addressPincode,
        addressLatitude: this.addressLatitude,
        addressLongitude: this.addressLongitude,
        addressCurrentPosition: this.addressCurrentPosition,
      };
      let reqUrl = `${POST_VENDORS}`;
      let token = await CommonServices.getUserToken();
      let headers = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .post(reqUrl, formData, headers)
        .then((response) => {
          let responseData = response.data;
          if (responseData.success == true) {
            this.fbMsg = responseData.message + " Please wait...!";
            this.fbDiv = "alert-success";
            this.fbWrapperShow = true;
            this.showForm = false;
            setTimeout(() => {
              this.$router.push("/vendors");
            }, 2000);
          } else {
            if (responseData.status == "ok") {
              this.fbMsg = responseData.message;
            } else {
              let swapfbmsg = "<ul>";
              for (const key in responseData.message) {
                if (Object.hasOwnProperty.call(responseData.message, key)) {
                  swapfbmsg += "<li>" + responseData.message[key] + "</li>";
                }
              }
              swapfbmsg += "</ul>";
              this.fbMsg = swapfbmsg;
            }
            this.fbDiv = "alert-danger";
            this.fbWrapperShow = true;
          }
        })
        .catch((error) => {
          console.log(error.response);
          let msg = "Server error";
          this.loaderShow = false;
          this.fbWrapperShow = true;
          this.fbDiv = "alert-danger";
          this.fbMsg = msg;
        });
    },
    isRequired(value) {
      if (value && value != null) {
        return true;
      }
      return "This field is required";
    },
  },
  async created() {
    await this.fetchCities();
    await this.detectLatLong();
    this.loaderShow = false;
  },
};
</script>

<!-- 
      addressCurrentPosition: JSON.stringify(this.addressCurrentPosition),
      console.log("formData");
      console.log(formData);
          // console.log("currentPosition");
          // console.log(currentPosition);
          // console.log("typeof currentPosition");
          // console.log(typeof currentPosition);
          // console.log("this.addressCurrentPosition");
          // console.log(this.addressCurrentPosition);
          // console.log("typeof this.addressCurrentPosition");
          // console.log(typeof this.addressCurrentPosition);
          // console.log(JSON.stringify(this.addressCurrentPosition));
    // selectedCity(newValues) {
    //   if (newValues.includes('selectAll')) {
    //     this.selectedCategories = this.categories.map(categories => categories.category_id);
    //   }
    //   }
      console.log("formData");
      console.log(formData);
              // console.log("responseData.message ", responseData.message);
      // if (value && value.trim()) {
          // $(".fbMsg1").html(response.message);
          // $(".fbDiv1").addClass("bg-success");
          // $(".fbWrapper1").show();
          // $("#formUpdateRemark").hide();
          // setTimeout(function () {
          //     $("#modalUpdateRemark").modal("hide");
          //     $("#contentWrapper").fadeOut();
          //     $("#loadingWrapper").fadeIn();
          //     $("#btnUpdateRemark").text("Update Remark");
          //     $("#btnUpdateRemark").prop("disabled", false);
          //     $(".btnModalClose").prop("disabled", false);
          //     // $("#openOrdersTable").DataTable().destroy();
          //     // $("#openOrdersTable tbody").html("");
          //     window.location.reload();
          // }, 3000);
          // $(".fbMsg1").html(response.message);
          // const element = responseData.message[key];
          // console.log("element ", element);
          // this.fbMsg = responseData.message;
          // $(".fbMsg1").append(
          //     '<ul class="p-0 m-0 pl-2 errorList"></ul>'
          // );
          // $.each(response.message, function (key, value) {
          //     $(".errorList").append(
          //         "<li>" + value.toString() + "</li>"
          //     );
          // });
          // $(".fbDiv1").addClass("bg-danger");
          // $(".fbWrapper1").show();
          // $("#btnUpdateRemark").text("Update Remark");
          // $("#btnUpdateRemark").prop("disabled", false);
          // $(".btnModalClose").prop("disabled", false);
          // console.log("responseData");
          // console.log(responseData);
      // onSubmit(values) {
      // async addVendor(e) {
      // e.preventDefault();
      // this.buttonDisabled = true;
      // console.log(values, null, 2);
      // console.log("form submitted");
      // console.log(values);

       -->

<!-- <button type="button" @click=addVendor class="btn btn-primary float-end">Submit</button> -->

<!-- <select class="form-select" name="cities" v-model="addressCity" required>
                    <option value="">Select City</option>
                    <option v-for="item in cities" :value="item.loc_city_id" :key="item.id">{{item.loc_city_title}}</option>
                  </select> -->
<!-- <select class="form-select" name="pincodes" v-model="addressPincode" required>
                  <option value="">Select Pincode</option>
                  <option
                    v-for="item in pincodes"
                    :value="item.pincode_id"
                    :key="item.id"
                  >
                    {{ item.pincode_title }}
                  </option>
                </select> -->

<!-- <div class="col-md-8 offset-md-2 col-sm-12">
    </div> -->
<!-- <Form method="post"> -->
<!-- <form novalidate @submit.prevent="onSubmit"> -->

<!-- <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="mt-3 mb-3 text-center">Fill below form to add vendor</h4>
            <hr />

            <div class="row mb-3">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="First name"
                  aria-label="First name"
                />
              </div>
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last name"
                  aria-label="Last name"
                />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="First name"
                  aria-label="First name"
                />
              </div>
              <div class="col">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Last name"
                  aria-label="Last name"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

<!-- 

        mobileNumber: this.mobileNumber,
        proprietorName: this.proprietorName,
        // mobileNumber: '',
        // proprietorName: '',

         -->
<!-- <div class="mb-3">
                    <input type="text" class="form-control" id="proprietorName" v-model="proprietorName" placeholder="Enter Owner Name" required>
                  </div> -->

<!-- console.log('addVendor button clicked');
          this.latLongStatusClasss = 'text-success';
        // latLongClass: 'bg-danger',
        // latLongStatus: '<span class="text-danger">Not Ok</span>',
        latLongStatusContent: '???',
        latLongStatusClass: 'text-danger', -->
<!-- <td>{{addressLatitude}} <span :class="latLongStatusClass">{{ latLongStatusContent }}</span></td> -->
<!-- <td>{{addressLongitude}} <span :class="latLongStatusClass">{{ latLongStatusContent }}</span></td> -->
<!-- <td>{{addressLatitude}} {{ latLongStatus }}</td> -->
<!-- <td>{{addressLatitude}} <span :class="latLongStatus">{{ latLongStatus }}</span></td> -->
<!-- <td>{{addressLongitude}} {{ latLongStatus }}</td> -->
<!-- <td>{{addressLongitude}} <span :class="latLongClass"></span></td> -->
<!-- // console.log('currentPosition');
          // console.log(currentPosition);
          // console.log(JSON.stringify(currentPosition, 0, 2));
          console.log('addressCurrentPosition');
          console.log(this.addressCurrentPosition);
        // let response = JSON.parse(error.request.response);
        // let msg = response.message;
        // this.buttonDisabled = false;

              :disabled="buttonDisabled" -->
<!-- <div class="mb-3">
                                <button type="submit" @click=mapsLocation class="btn btn-secondary btn-sm" v-if="showLocationBtn">Detect Location</button>
                              </div> -->

<!-- showLocationBtn: true,
                      // console.log('this.addressLatitude');
                      // console.log(this.addressLatitude);
                      // console.log(this.addressLongitude);
                      // if(this.addressLatitude == "" || this.addressLongitude =="") {
                      //   this.fbWrapperShow = true;
                      //   this.fbDiv = 'alert-danger';
                      //   this.fbMsg = 'Geolocation detection failed';
                      // }

                    // this.showLocationBtn = false;
                    // document.getElementById("btnDetectLatLong").val('hi');
                    // console.log(e.target);
                    // e.target.innerText = "Detecting Location...!";
                      // alert('Geolocation is not supported in this browser')
                    // this.showLocationBtn = true;

                      // currLocation: '',
                        // console.log('currentPosition');
                        // console.log(currentPosition);
                        // this.currLocation = {
                        //   latitude: currentPosition.coords.latitude,
                        //   longitude: currentPosition.coords.longitude
                        // }
                    // }
                    // console.log('currLocation');
                    // console.log(this.currLocation);
                    // https://maps.google.com/?q=[lat],[long]
                    // https://maps.google.com/?q=-37.866963,144.980615 -->

<!-- <label for="mobileNumber" class="form-label">Mobile Number</label> -->
<!-- <label for="proprietorName" class="form-label">Proprietor Name</label> -->
<!-- <label for="businessName" class="form-label">Business Name</label> -->
<!-- <label for="address" class="form-label">Address Details</label> -->
<!-- <label for="addressMaps" class="form-label">Address Maps</label> -->

<!--
              <div class="mb-3">
                <label for="mobileNumber" class="form-label">Mobile Number</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="mobileNumber" v-model="mobileNumber" placeholder="Enter Mobile Number" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="proprietorName" class="form-label">Proprietor Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="proprietorName" v-model="proprietorName" placeholder="Enter Owner Name" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="businessName" class="form-label">Business Name</label>
                <div class="col-sm-9">
                  <input type="text" class="form-control" id="businessName" v-model="businessName" placeholder="Enter Business Name" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="address" class="form-label">Address Details</label>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="addressNo" v-model="addressNo" placeholder="Shop No" required>
                </div>
                <div class="col-sm-6">
                  <input type="text" class="form-control" id="addressLine1" v-model="addressLine1" placeholder="Address Line 1" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="address" class="form-label"></label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" id="addressLine2" v-model="addressLine2" placeholder="Address Line 2" required>
                </div>
                <div class="col-sm-3">
                  <input type="text" class="form-control" id="addressLandmark" v-model="addressLandmark" placeholder="Landmark" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="address" class="form-label"></label>
                <div class="col-sm-6">
                  <select class="form-select" id="cities" v-model="addressCity" required>
                    <option value="">Select City</option>
                    <option v-for="item in cities" :value="item.city_id" :key="item.id">{{item.city_title}}</option>
                  </select>
                  <input type="text" class="form-control" id="addressCity" v-model="addressCity" required>
                </div>
                <div class="col-sm-3">
                  <select class="form-select" id="pincodes" v-model="addressPincode" required>
                    <option value="">Select Pincode</option>
                    <option v-for="item in pincodes" :value="item.pincode_id" :key="item.id">{{item.pincode_title}}</option>
                  </select>
                  <input type="text" class="form-control" id="addressPincode" v-model="addressPincode" required>
                </div>
              </div>
              <div class="mb-3">
                <label for="addressMaps" class="form-label">Address Maps</label>
                <div class="col-sm-3">
                  <button type="button" class="btn btn-secondary btn-sm">Deduct Maps</button>
                </div>
              </div>
              <div class="mb-3">
                <div class="col-sm-9 offset-3">
                  <button type="submit" @click=addVendor class="btn btn-primary" :disabled="buttonDisabled">Submit</button>
                </div>
              </div>


            -->
